import { AbstractPreset, config } from "./AbstractPreset";

export default class RectangleNoneEdges extends AbstractPreset {
	getName(): string {
		return 'rectangleNoneEdges';
	}

	getConfig(): config {
		return {
			"base": {
				"shape": "rectangle",
				"presetShape": this.getName(),
				"primitives": {
					"width": 50,
					"length": 50
				},
			},
			"drillholes": {
				"type": "edges",
				"edgeType": "corners",
				"offset": 30,
			},
			"cutouts": [],
		};
	}
}
